<template>
  <div class="register-layout">
    <div class="form-wrapper">
      <div class="form-container has-text-left">
        <h1 class="is-size-5 has-text-weight-semibold">Create Judge Profile</h1>
        <p>All fields are mandatory.</p>
        <br>
        <div class="columns">
          <div class="column">
            <TextField
              :label="'First Name'"
              :placeholder="'John'"
              :name="'firstname'"
              :initial-value="firstName"
              :message="firstNameMessage"
              :extraClass="firstNameMessage ? firstNameMessage.class : ''"
              @changedValue="saveFirstName"
            />
          </div>
          <div class="column">
            <TextField
              :label="'Last Name'"
              :placeholder="'Snow'"
              :name="'lastname'"
              :initial-value="lastName"
              :message="lastNameMessage"
              :extraClass="lastNameMessage ? lastNameMessage.class : ''"
              @changedValue="saveLastName"
            />
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <TextField
              :label="'Email'"
              :type="'email'"
              :placeholder="'example@example.com'"
              :initial-value="email"
              :message="emailMessage"
              :disabled="true"
            />
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <TextField
              :label="'Password'"
              :type="'password'"
              :placeholder="'Type in a password'"
              :initial-value="password"
              :message="passwordMessage"
              :extraClass="passwordMessage ? passwordMessage.class : ''"
              @changedValue="savePassword"
            />
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <Checkbox
              :label="'&nbsp;'"
              :initial-value="terms"
              @changedValue="saveTerms"
            />
            I agree to the
            <a
              href='#'
              @click.prevent="toggleTermsModal"
            >terms and conditions</a>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <Checkbox
              :label="'&nbsp;'"
              :initial-value="privacy"
              @changedValue="savePrivacy"
            />
            I accept the
            <a
              href='#'
              @click.prevent="togglePrivacyModal"
            >privacy policy</a>
          </div>
        </div>

        <div class="level mt is-mobile">
          <div class="level-left">&nbsp;</div>
          <div class="level-right">
            <a
              href="#"
              :class="{ 'is-loading': submitting }"
              class="button is-warning has-text-weight-bold level-item"
              :disabled="!isValid || submitting"
              @click.prevent="submitForm"
            >Next</a>
          </div>
        </div>
        <TermsModal
          v-if="isOpenTermsModal"
          :is-open="isOpenTermsModal"
          @closeModal="toggleTermsModal"
        />
        <PrivacyModal
          v-if="isOpenPrivacyModal"
          :is-open="isOpenPrivacyModal"
          @closeModal="togglePrivacyModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import Checkbox from '@/components/inputs/Checkbox'
import TermsModal from '@/components/modals/TermsModal'
import PrivacyModal from '@/components/modals/PrivacyModal'
import inputMessages from '@/configs/inputMessages'

export default {
  name: 'Signup',
  components: {
    TextField,
    Checkbox,
    TermsModal,
    PrivacyModal
  },
  data () {
    return {
      //  Values
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      terms: false,
      privacy: false,
      //  Errors
      firstNameMessage: false,
      lastNameMessage: false,
      emailMessage: {
        value: 'You will use this email to login to your account'
      },
      passwordMessage: inputMessages.passwordRequirement,
      //  State
      isOpenTermsModal: false,
      isOpenPrivacyModal: false,
      submitting: false
    }
  },
  mounted () {
    if ('inviteId' in this.$router.currentRoute.params) {
      this.inviteId = this.$router.currentRoute.params.inviteId
      this.$store
        .dispatch('invites/GET_INVITE', this.inviteId)
        .then(res => {
          if (res.data !== null) {
            this.email = res.data.email
            this.$store.commit('register/saveEmail', this.email)
          } else {
            this.$toasted.error('This signup is no longer valid or doesn\'t exist')
            this.$router.push({ name: 'home' })
          }
        })
    } else {
      this.$router.push({ name: 'home' })
    }
  },
  computed: {
    isValid () {
      return this.validateFields()
    }
  },
  methods: {
    saveFirstName (value) {
      if (value.trim().length > 0) {
        this.firstName = value.trim()
        this.firstNameMessage = false
      } else {
        this.firstNameMessage = inputMessages.required
      }
    },
    saveLastName (value) {
      if (value.trim().length > 0) {
        this.lastName = value.trim()
        this.lastNameMessage = false
      } else {
        this.lastNameMessage = inputMessages.required
      }
    },
    savePassword (value) {
      value = value.trim()
      if (value.length >= 6) {
        if (this.validPasswordFormat(value)) {
          this.password = value
          this.passwordMessage = inputMessages.passwordRequirement
          this.$store.commit('register/savePassword', this.password)
        } else {
          this.passwordMessage = inputMessages.passwordError
        }
      } else if (value.length > 0 && value.length < 6) {
        this.passwordMessage = inputMessages.passwordError
      } else {
        this.passwordMessage = inputMessages.required
      }
    },
    saveTerms (value) {
      this.terms = value
    },
    savePrivacy (value) {
      this.privacy = value
    },
    // Validation
    validPasswordFormat (value) {
      if (value.match(/[A-Z]/) !== null && value.match(/[0-9]/) !== null) {
        return true
      } else {
        return false
      }
    },
    validateFields () {
      let valid = false
      if (
        this.firstName.length > 0 &&
        this.lastName.length > 0 &&
        this.email.length > 0 &&
        this.validPasswordFormat(this.password) &&
        this.terms &&
        this.privacy
      ) {
        valid = true
      }
      return valid
    },
    // Submitting
    submitForm () {
      if (this.isValid) {
        this.submitting = true

        this.$store
          .dispatch('invites/SAVE_USER', {
            inviteId: this.inviteId,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            terms: this.terms,
            privacy: this.privacy
          })
          .then((res) => {
            this.$router.push({ name: 'register-complete' })
          })
          .catch(err => {
            this.$toasted.error('Error creating your account')
            console.log(err)
            this.submitting = false
          })
      }
    },
    toggleTermsModal () {
      this.isOpenTermsModal = !this.isOpenTermsModal
    },
    togglePrivacyModal () {
      this.isOpenPrivacyModal = !this.isOpenPrivacyModal
    }
  }
}
</script>

<style lang="scss">
  .form-wrapper{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    z-index: 10;

    @include until($tablet) {
      align-items: flex-start;
    }

    .form-container{
      width: 550px;
      max-width: 550px;
      height: auto;
      padding: 1.5em 1em;
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      border-radius: 4px;
      background: #FAFAFA;

      @include until($tablet) {
        box-shadow: none;
        border-radius: 0px;
      }
      .mt{
        margin-top: 15px;
      }
    }
  }
  .parent-data{
    padding: 15px;
    background: $gray-lighter;
    border-radius: 4px;
    margin-bottom: 15px;
  }
</style>
